<template>
  <div class="personStatus">
    <slot />
    <span v-if="isActive" class="personStatusInfo personStatusInfoActive">{{
      eventsData.personFilledLabel
    }}</span>
    <span v-else class="personStatusInfo">{{
      eventsData.personNotFilledLabel
    }}</span>
  </div>
</template>

<script>
export default {
  name: "PersonStatus",
  props: ["isActive"],
  computed: {
    eventsData() {
      return this.$t("events");
    }
  }
};
</script>
<style scoped lang="scss">
@import "src/assets/style/vars";

.personStatus {
  display: flex;
  grid-gap: 8px;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  line-height: 1.15;
  font-weight: 700;
}

.personStatusInfo {
  font-weight: 400;
  color: $grey;
  opacity: 0.8;
}

.personStatusInfoActive {
  color: $activeColor;
  opacity: 1;
}
</style>
